// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {completePartialDebit} from './debit';
import {postDebit} from '../../shared/repositories';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const updatePartialDebit = (debit, auditNumber) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await postDebit(debit);

            successAlertBar(translate('DEBIT_SUBMITTED_SUCCESSFULLY'));

            completePartialDebit(auditNumber)(dispatch);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/action-creators/update-debit.js